import { Button } from "@/components/ui/button";
import logoImage from "@assets/favicon new no background cc6633.png";
import { useAuth } from "@/hooks/useAuth";
export default function MarketingHeader() {
  const { isAuthenticated, user, isLoading } = useAuth();

  const profileCompleted = user?.profileCompleted === "true";
  const hasUserType = user?.userType && user.userType !== "";

  const getAuthenticatedDestination = () => {
    if (profileCompleted) return "/dashboard";
    if (hasUserType) {
      const membershipRoutes: Record<string, string> = {
        Shipper: "/select-membership/shipper",
        Carrier: "/select-membership/carrier",
        Broker: "/select-membership/broker",
      };
      return membershipRoutes[user?.userType || ""] || "/login";
    }
    return "/login";
  };

  const getButtonText = () => {
    if (!isAuthenticated) return "Start Free";
    if (profileCompleted) return "Go to Dashboard";
    return "Continue Setup";
  };

  return (
    <header className="sticky top-0 z-50 bg-background border-b">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <a href="/" className="flex items-center gap-2" data-testid="link-logo">
          <img src={logoImage} alt="Fill The Trucks" className="h-20" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          <a
            href="/how-it-works"
            className="text-sm font-medium hover:text-primary transition-colors"
            data-testid="link-how-it-works"
          >
            How It Works
          </a>
          <a
            href="/pricing"
            className="text-sm font-medium hover:text-primary transition-colors"
            data-testid="link-pricing"
          >
            Pricing
          </a>
          <a
            href="/support"
            className="text-sm font-medium hover:text-primary transition-colors"
            data-testid="link-contact-us"
          >
            Contact Us
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {!isAuthenticated && !isLoading && (
            <Button
              variant="ghost"
              data-testid="button-login"
              onClick={() => (window.location.href = "/login")}
            >
              Log In
            </Button>
          )}
          {isAuthenticated && (
            <Button
              variant="ghost"
              data-testid="button-logout"
              onClick={() => (window.location.href = "/api/logout")}
            >
              Log Out
            </Button>
          )}
          <Button
            data-testid="button-start-free"
            onClick={() =>
              (window.location.href = isAuthenticated
                ? getAuthenticatedDestination()
                : "/register")
            }
          >
            {getButtonText()}
          </Button>
        </div>
      </div>
    </header>
  );
}
